export const KC_MATERIAL_DATE_FORMATS = {
    parse: {
      dateInput: 'DD/MM/YYYY', 
    },
    display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMMM YYYY',
      dateA11yLabel: 'DD/MM/YYYY',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };